import QS from 'qs'
import axios from 'axios'

const baseURL = process.env.REACT_APP_COMPONENT_URL
const marketplaceURL = process.env.REACT_APP_COMPONENT_REGISTRY_URL
const localBaseURL = process.env.REACT_APP_DEV_SERVER_URL
const cache = {}

export const getLibraryDependencies = async (app, localLibraries = [], useNewReactNative = false) => {
  let { librariesUsed } = app

  let libraries = []

  if (librariesUsed) {
    const { data } = await axios.get(`${marketplaceURL}/api/libraries`, {
      params: {
        names: encodeURIComponent(
          JSON.stringify(['@protonapp/material-components', ...librariesUsed])
        ),
        orgId: app?.OrganizationId,
        appId: app?.id,
        versionRN: useNewReactNative ? '0.77.2' : '0.74.2',
      },
    })

    libraries = data
  }

  // add local libraries
  localLibraries.map(localLibrary => {
    const filtered = libraries.filter(lib => lib?.name === localLibrary) || []

    if (filtered.length > 0) return null
    return (libraries = [...libraries, { name: localLibrary, version: 'dev' }])
  })

  return libraries
}

// Returns promise
export const loadLibrary = (name, version, isLocal, authToken) => {
  let url = `${baseURL}/${name}/${version}/runtime-${version}.js`

  if (isLocal && authToken) {
    url = `${localBaseURL}/libraries/${name}/runtime-dev.js?authToken=${authToken}`
  }

  // Check if already in cache
  if (cache[url]) {
    return cache[url]
  }

  let script = document.createElement('script')
  script.src = url
  script.setAttribute('crossorigin', '')
  document.body.appendChild(script)

  let promise = new Promise((resolve, reject) => {
    script.addEventListener('load', () => {
      window.setTimeout(() => {
        resolve()
      }, 100)
    })

    script.addEventListener('error', () => {
      reject(new Error(`Script could not load: ${url}`))
    })
  })

  cache[url] = promise

  return promise
}

export const loadLibraries = async(app, useNewRN) => {
  let authToken = getAuthToken()
  let useNewReactNative = shouldUseNewReactNative(app, useNewRN)
  let localLibraries = []

  if (authToken) {
    try {
      const params = { authToken }
      const url = `${localBaseURL}/libraries/?${QS.stringify(params)}`
      const { data } = await axios.get(url)
      if (Array.isArray(data)) localLibraries = data
    } catch (err) {
      // Do nothing
    }
  }

  const libraryDependencies = await getLibraryDependencies(
    app,
    localLibraries,
    useNewReactNative
  )

  let promises = libraryDependencies.map(({ name, version }) => {
    if (localLibraries.includes(name)) {
      return loadLibrary(name, null, true, authToken)
    } else {
      return loadLibrary(name, version)
    }
  })

  return Promise.allSettled(promises)
}



export const getParams = () => {
  return QS.parse(window.location.search.substring(1))
}

export const getAuthToken = () => {
  return getParams().sessionToken
}

export const shouldUseNewReactNative = (app, hasNewReactNativeSwitcher) => {
  return app?.useNewRNVersion && hasNewReactNativeSwitcher
}

export const getLibraries = app => {
  return window.protonRuntime || {}
}
